import { Redirect, Route, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import styles from "./dashboard.module.scss";
import {
  Purchases,
  Security
} from "./Modules";
import { useAppSelector } from "../../store/hooks";
import { CircularProgress, Typography } from "@mui/material";

const Dashboard = () => {
  const { user, isLoading } = useAppSelector((state) => state.app);
  const location = useLocation();
  if (isLoading) return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      <div className="text-center">
        <CircularProgress className="mb-1"/>
        <Typography variant="caption" className="d-block">Loading</Typography>
      </div>
    </div>
  )
  if (!user && !isLoading) return <Redirect to="/" />;
  else if (location.pathname === "/dashboard" || location.pathname === "/dashboard/") {
    return <Redirect to="/dashboard/purchases" />;
  }
  return (
    <div className={`${styles.dashboard}`}>
      <div className="container-fluid h-100">
        <div className="row h-100">
          <Sidebar />
          <div className={`${styles.content} col-md-9 col-12 pt-3`}>
            <Route
              exact
              path={"/dashboard/purchases"}
              render={(props) => <Purchases {...props}/>}
            />
            <Route
              exact
              path={"/dashboard/security"}
              render={(props) => <Security {...props}/>}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
